module.exports = __webpack_public_path__ + "static/media/1009226.1c49b509.png";